"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getServiceContextFolderId_1 = require("owa-mail-store/lib/services/utils/getServiceContextFolderId");
var getServiceItemIds_1 = require("owa-mail-store/lib/services/utils/getServiceItemIds");
var moveItemRequest_1 = require("owa-service/lib/factory/moveItemRequest");
var moveItemOperation_1 = require("owa-service/lib/operation/moveItemOperation");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
/**
 * The service command to move items to a specified destination folder
 * @param itemIds the ids of the items to be moved
 * @param destinationFolderId the id of destination folder to move to
 * @return a Promise which contains the MoveItemResponse
 */
function moveItemsService(itemIds, destinationFolderId, sourceFolderId) {
    var requestBody = configureRequestBody(itemIds, destinationFolderId);
    return moveItemOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body;
    });
}
exports.default = moveItemsService;
/**
 * Configure the MoveItemRequest body
 * @param itemIds the ids of the items to be moved
 * @param destinationFolderId the id of destination folder to move to
 * @return a Promise which contains the MoveItemResponse
 */
function configureRequestBody(itemIds, destinationFolderId) {
    return moveItemRequest_1.default({
        ToFolderId: getServiceContextFolderId_1.default(destinationFolderId),
        ItemIds: getServiceItemIds_1.default(itemIds),
        ReturnNewItemIds: true,
    });
}
//# sourceMappingURL=moveItemsService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/services/moveItemsService.js
// module id = 5602
// module chunks = 62